import { IVideoStyle } from './types';

enum Theme {
  DUOTONE = '196',
  SALE = '167',
  KIDS = '174',
  EDGY = '207',
  FASHION = '210',
  POSH = '211',
  MINIMAL = '212',
  TRIGONO = '213',
  BRUSHSTROKE = '219',
  XOXO = '222',
}

const DEFAULT_THEME = Theme.DUOTONE;

const DEFAULT_THEME_STYLE: IVideoStyle = {
  activeFont: 'BERNIER',
  primaryColor: '#000000',
  secondaryColor: '#FFFFFF',
};

export { DEFAULT_THEME, DEFAULT_THEME_STYLE, Theme };
